<template>
  <b-container>
    <b-row class="text-center">
      <b-col></b-col>
      <b-col cols="10">
        <img src="@/assets/logo/svg/dashtech-alt-logo.svg" width="200px" class="my-3" />
        <BaseMessageBlock :messages="successMessage" type="Success"></BaseMessageBlock>
        <b-card
          title="Unsubscribe From Project"
          style="background-color: #f2f8f8"
          class="mb-3"
        >
          <div class="text-center">
            <p>
              If you want to unsubscribe from your project click the button down
              below
            </p>
          </div>
        </b-card>
        <div class="text-center">
          <!-- <h3 class="surveyTitle">This is whatever project</h3> -->
              <div class="text-center">
                <!-- <p>
                  If you want to unsubscribe from your project click the button
                  down below
                </p> -->
              </div>
              <b-button
                type="submit"
                size="lg"
                variant="danger"
                style="width: 100px"
                @click="handleSubmit"
              >
                <b-spinner v-if="sending" label="Spinning"></b-spinner>
                <div v-else>Leave Project</div>
              </b-button>
        </div>
        <div v-if="loading" class="text-center">
          <h5>Please wait while we try to load this page.</h5>
          <img src="/assets/loading.gif" />
        </div>
        <BaseMessageBlock :messages="uniqueErrors"></BaseMessageBlock>
        <BaseMessageBlock :messages="messages" :type="'Success'"></BaseMessageBlock>
      </b-col>
      <b-col></b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import authMixin from "@/mixins/auth-mixin.js";

export default {
  name: "LeaveProject",
  mixins: [authMixin],
  data() {
    return {
      projectRelations: {},
      userId: "",
      projectId: "",
      tenantId: "",
      errors: [],
      messages: [],
      successMessage: [],
      inactive: false,
      loading: false,
      sending: false,
    };
  },
  mounted() {
    this.userId = this.$route.query.uid;
    this.projectId = this.$route.query.pid;
    if (!this.userId || !this.projectId) {
      this.loading = false;
      this.errors.push({ message: "Invalid Request" });
      return;
    }
    this.loading = true;
    axios
      .get(
        `${this.$api_url}/project/${this.projectId}/leave-project/${this.userId}`,
        this.getReqConfig()
      )
      .then((response) => {
        let newData = response.data;
        if (newData == null) {
          let returnUrl = `/leave-project?uid=${this.userId}&pid=${this.projectId}`;
          this.$router.push({ name: 'Login', query: { message: 'User Has Already Left Project', returnUrl: returnUrl }});
          return;
        }
        //will do some setting of variables or calling a modal to open up
          this.$store.dispatch("setTenantId", newData.tenantId)
      })
      .catch((err) => {
        this.errors.push(...this.$helpers.formatErrors(err));
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    handleSubmit() {
    //   this.sending = true;
      this.inactive = true;
      axios
        .put(
          `${this.$api_url}/inactive/${this.userId}/project/${this.projectId}/${this.inactive}`,
          null,
          this.getReqConfig()
        )
        .then((response) => {
        //console.log(response.data)

          let returnUrl = `/project/${this.projectId}`;
          this.$router.push({
            name: "Login",
            query: {
              message: "Your Message has Been Sent!",
              returnUrl: returnUrl,
            },
          });
        })
        .catch((err) => {
          this.errors.push(err);
          this.sending = false;
        });
    },
  },
  computed: {
    uniqueErrors() {
      return Array.from(new Set(this.errors.map(e => e.message))).map(m => ({message: m}));
    }
  }
};
</script>

<style scoped>
.surveyTitle {
  color: #555;
}
</style>